//登记保存时的信息
export const _saveData ={
    copyrightType	:"1",	//	权利归属方式. 1.个人作品 2.合作作品 3.法人作品 4.职务作品 5.委托作品
    authorIds	:"",	//	作者id 以英文逗号分隔
    powerUserIds	:"",	//	著作权人id 以英文逗号分隔
    creativeType	:"",	//	作品创作性质 1:原创; 2:改编; 3:翻译; 4:汇编 5:注释; 6:整理; 7:其他
    workFullName	:"",	//	作品名称
    workUrl	:"",	//	作品url 作品文件
    workType	:"",	//	 作品类型 ：： 1：设计手稿 2：设计图 3：产品摄影 4：产品视频 5：设计创意稿 )
    completeDateEnd	:"",	//	创作完成时间
    completeCity	:"",	//	创作完成城市
    publishStatus	:"",	//	是否首次发表（否：0，是：1）
    publishDate	:"",	//	发布发布日期（已发布）
    publishCity	:"",	//	发布城市（已发布）
    otherAttachments	:"",	//		附件
    workInstruction	:"",	//创作声明
    powerScope	:"",	//	权利范围	权益范围
    modifyNumber:"1",   //修改次数
    creationOriginality	:"",	//	独创性
    createIntention	:"",	//	创作意图
    creativePropertyStatement: "",//创作性质说明

    id	:"",	//	编号	(可以不传)
    orderSeqNo	:"",	//	订单号	(可以不传)
    rejectReason	:"",	//	驳回原因	(可以不传)
    workStatement	:"",	//	著作权原创声明书url
    workCorporate	:"",	//	作品证明文件url
    completeCountry	:"",	//	创作完成国家
    completeProvince	:"",	//	创作完成省
    publishCountry	:"",	//	发表国家（已发布）
    publishProvince	:"",	//	发表省（已发布）
    publishUrl	:"",	//	作品发布的位置(URL)
    powerBy	:"1",	//	权利获得方式
    applyType	:"",	//	申请方式
    prn	:"",	//	受理单号
    mdci	:"",	//	版权证书编号
    dciUrl	:"",	//	版权证书url
    creationDetail	:"",	//	创作说明
    completeDateBegin	:"",	//	创作开始时间
    applySn	:"",	//	登记单唯一编号
    workJobProduction	:"",	//	职务作品文件声明url
    entrustStatementUrl	:"",	//	委托作品创作声明url
    entrustContent	:"",	//	委托说明

};
//获取权利人的信息
export const _getObligeeParams={
    pageNumber		:		1	,
    pageSize		:		200	,
    sort		:		""	,
    order		:		""	,
    id		:		""	,
    name		:		""	,
    obligeeType		:		""	,
    authMethod		:		""	,
    identityType		:		""	,
    identityNumber		:		""	,
    address		:		""	,
    country		:		""	,
    province		:		""	,
    city		:		""	,
    registerId		:		"20000188"	,
    attachment1		:		""	,
    attachment1Uuid		:		""	,
    attachment2		:		""	,
    attachment2Uuid		:		""	,
    attachment3		:		""	,
    attachment3Uuid		:		""	,
    attachStartTime		:		""	,
    attachEndTime		:		""	,
    isRegister		:		""	,
    legalName		:		""	,
    legalIdentityNumber		:		""	,
    legalPicCardOn		:		""	,
    legalPicCardBack		:		""	,
    legalStartTime		:		""	,
    legalEndTime		:		""	,
};